<template>
    <div class="mt-3">
        <div class="card">
            <div class="card-header">
                Update Waktu Antrean
            </div>
            <div class="card-body">
                <h5 class="card-title">Cari Registrasi</h5>

                <div class="row mt-5">
                    <div class="col-md-2 text-right">
                        <label for="regno">Nomor Registrasi</label>
                    </div>
                    <div class="col-md-2">
                        <input type="text" class="form-control" id="regno" v-model="regno">
                    </div>
                    <div class="col-md-2">
                        <button class="btn btn-sm btn-primary" @click="getRegistrasi">Cari</button>
                    </div>
                </div>

                <div v-if="data_pasien && data_pasien.pasien && data_pasien.installasi">
                    <hr>
                    <h5 class="card-title">Data Registrasi</h5>

                    <div class="mt-3">
                        <div class="row">
                            <div class="col-md-2 text-right">Tanggal</div>
                            <div class="col-md-4">: {{ data_pasien.Regdate | formatDate }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 text-right">Medrec</div>
                            <div class="col-md-4">: {{ data_pasien.Medrec }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 text-right">Nama</div>
                            <div class="col-md-4">: {{ data_pasien.Firstname }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 text-right">Tanggal Lahir</div>
                            <div class="col-md-4">: {{ data_pasien.Bod | formatDate }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 text-right">Instalasi</div>
                            <div class="col-md-4">: {{ data_pasien.installasi.NMPoli }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 text-right">Dokter</div>
                            <div class="col-md-4">: {{ data_pasien.dokter.NmDoc }}</div>
                        </div>
                    </div>
                </div>

                <div v-if="data_pasien && data_pasien.pasien && data_pasien.installasi">
                    <hr>
                    <h5 class="card-title">Update Waktu Antrean</h5>

                    <div class="mt-3">
                        <div class="row">
                            <div class="col-md-6">
                                <button class="btn btn-sm btn-danger" @click="batalkanAntean">Batalkan Antrean</button>
                            </div>
                        </div>
                        <ol class="mt-3">
                            <li>
                                <div class="row">
                                    <div class="col">Mulai waktu tunggu admisi</div>
                                    <div class="col" v-if="register_task_data.task_id_1 == null"><button @click="updateRegisterTaskId(1)" class="btn btn-sm btn-outline-success">Update</button></div>
                                    <div class="col" v-if="register_task_data.task_id_1">{{ register_task_data.task_id_1 }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="row">
                                    <div class="col">Akhir waktu tunggu admisi/Mulai waktu layan admisi</div>
                                    <div class="col" v-if="register_task_data.task_id_2 == null"><button @click="updateRegisterTaskId(2)" class="btn btn-sm btn-outline-success">Update</button></div>
                                    <div class="col" v-if="register_task_data.task_id_2">{{ register_task_data.task_id_2 }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="row">
                                    <div class="col">Akhir waktu layan admisi/Mulai waktu tunggu poli</div>
                                    <div class="col" v-if="register_task_data.task_id_3 == null"><button @click="updateRegisterTaskId(3)" class="btn btn-sm btn-outline-success">Update</button></div>
                                    <div class="col" v-if="register_task_data.task_id_3">{{ register_task_data.task_id_3 }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="row">
                                    <div class="col">Akhir waktu tunggu poli/Mulai waktu layan poli</div>
                                    <div class="col" v-if="register_task_data.task_id_4 == null"><button @click="updateRegisterTaskId(4)" class="btn btn-sm btn-outline-success">Update</button></div>
                                    <div class="col" v-if="register_task_data.task_id_4">{{ register_task_data.task_id_4 }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="row">
                                    <div class="col">Akhir waktu layan poli/Mulai waktu tunggu farmasi</div>
                                    <div class="col" v-if="register_task_data.task_id_5 == null"><button @click="updateRegisterTaskId(5)" class="btn btn-sm btn-outline-success">Update</button></div>
                                    <div class="col" v-if="register_task_data.task_id_5">{{ register_task_data.task_id_5 }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="row">
                                    <div class="col">Akhir waktu tunggu farmasi/Mulai waktu layan farmasi membuat obat</div>
                                    <div class="col" v-if="register_task_data.task_id_6 == null"><button @click="updateRegisterTaskId(6)" class="btn btn-sm btn-outline-success">Update</button></div>
                                    <div class="col" v-if="register_task_data.task_id_6">{{ register_task_data.task_id_6 }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="row">
                                    <div class="col">Akhir waktu obat selesai dibuat</div>
                                    <div class="col" v-if="register_task_data.task_id_7 == null"><button @click="updateRegisterTaskId(7)" class="btn btn-sm btn-outline-success">Update</button></div>
                                    <div class="col" v-if="register_task_data.task_id_7">{{ register_task_data.task_id_7 }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="row">
                                    <div class="col">Tidak hadir/Batal</div>
                                    <div class="col" v-if="register_task_data.task_id_8 == null"><button @click="updateRegisterTaskId(8)" class="btn btn-sm btn-outline-success">Update</button></div>
                                    <div class="col" v-if="register_task_data.task_id_8">{{ register_task_data.task_id_8 }}</div>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>

                <div v-else>
                    <hr>

                    <div class="mt-3">
                        Data Tidak Ditemukan
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            regno: '',
            data_pasien: null,
            register_task_data: {
                task_id_1: null,
                task_id_2: null,
                task_id_3: null,
                task_id_4: null,
                task_id_5: null,
                task_id_6: null,
                task_id_7: null,
                task_id_8: null,
            },
            keterangan_batal: 'Terjadi perubahan jadwal dokter, silahkan daftar kembali'
        }
    },
    create() {
        //
    },
    methods: {
        getRegistrasi() {
            this.$isLoading(true)
            let uri = '/api/update-waktu-antrean/get-registrasi?regno=' + this.regno

            this.axios.get(uri).then(response => {
                this.data_pasien = response.data.registrasi

                let reg_task_data = null
                if (this.data_pasien) {
                    reg_task_data = response.data.list_waktu_task_id.metadata != undefined ? [] : response.data.list_waktu_task_id
                }

                console.log(reg_task_data)

                this.register_task_data = []

                if (reg_task_data.length > 0) {
                    reg_task_data.forEach(data => {
                        switch (data.taskid) {
                            case 1:
                            case '1':
                                this.register_task_data.task_id_1 = 'selesai: ' + data.waktu
                                break;
                            case 2:
                            case '2':
                                this.register_task_data.task_id_2 = 'selesai: ' + data.waktu
                                break;
                            case 3:
                            case '3':
                                this.register_task_data.task_id_3 = 'selesai: ' + data.waktu
                                break;
                            case 4:
                            case '4':
                                this.register_task_data.task_id_4 = 'selesai: ' + data.waktu
                                break;
                            case 5:
                            case '5':
                                this.register_task_data.task_id_5 = 'selesai: ' + data.waktu
                                break;
                            case 6:
                            case '6':
                                this.register_task_data.task_id_6 = 'selesai: ' + data.waktu
                                break;
                            case 7:
                            case '7':
                                this.register_task_data.task_id_7 = 'selesai: ' + data.waktu
                                break;
                            case 8:
                            case '8':
                                this.register_task_data.task_id_8 = 'selesai: ' + data.waktu
                                break;

                            default:
                                break;
                        }
                    });
                } else {
                    this.register_task_data.task_id_1 = null
                    this.register_task_data.task_id_2 = null
                    this.register_task_data.task_id_3 = null
                    this.register_task_data.task_id_4 = null
                    this.register_task_data.task_id_5 = null
                    this.register_task_data.task_id_6 = null
                    this.register_task_data.task_id_7 = null
                    this.register_task_data.task_id_8 = null
                }

                this.$isLoading(false)
            })
        },
        updateRegisterTaskId(task_id) {
            this.$isLoading(true)
            let uri = '/api/update-waktu-antrean/update-task-id'

            this.axios.post(uri, {reg_id: this.regno, task_id: task_id}).then(response => {
                if (response.data.status == 'failed') {
                    this.$swal.fire(response.data.message, "", "error");
                }
                this.getRegistrasi()
            })
        },
        batalkanAntean() {
            this.$isLoading(true)
            let uri = '/api/update-waktu-antrean/batalkan-antrean'

            this.axios.post(uri, { kode_booking: this.regno, keterangan: this.keterangan_batal }).then(response => {
                this.$isLoading(false)
                if (response.data.status == 'success') {
                    this.$swal.fire('Antrean Berhasil Dibatalkan', "", "success");
                } else {
                    this.$swal.fire(response.data.message, "", "error");
                }
            })
        }
    }
}
</script>
